module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg_blue"
  }, [_c('div', {
    staticClass: "container_wrap"
  }, [_c('el-breadcrumb', {
    staticClass: "breadcrumb",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/indexpc'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(" 考级测试")])], 1), _vm._v(" "), _c('el-alert', {
    staticClass: "elalert",
    attrs: {
      "title": "温馨提示",
      "type": "warning"
    }
  }, [_vm._v("\n      1.请根据自己的身份选择不同的考试类型"), _c('br'), _vm._v("\n      2.游客身份可以测试客观题，不可以测试实践题。"), _c('br'), _vm._v("\n      3.理论测试共20道选择题，16道单选题，4道多选题，得分大于等于总分的90%则通过客观题部分的测试并进入实践题测试；实践题共三道，可任选一道进行作答。"), _c('br')]), _vm._v(" "), _c('el-steps', {
    staticClass: "elsteps",
    attrs: {
      "space": 200,
      "active": 1,
      "finish-status": "success"
    }
  }, [_c('el-step', {
    attrs: {
      "title": "报名信息"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "理论测试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "实践考试"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "考级结果"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "查看证书"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "left_and_right_container"
  }, [_c('div', {
    staticClass: "container_left"
  }, [_c('div', {
    staticClass: "container_left_content"
  }, [_c('div', {
    staticClass: "container_left_content_img"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.user.face
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("姓名：")]), _vm._v(_vm._s(_vm.row.user.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("会员号：")]), _vm._v(_vm._s(_vm.row.kaoji.name) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "container_left_content_name"
  }, [_c('span', [_vm._v("题数：")]), _vm._v(_vm._s(_vm.row.question_list.length) + "道\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container_center"
  }, [_c('div', {
    staticClass: "container_center_grade"
  }, [_vm._v("得分：98分")]), _vm._v(" "), _c('div', {
    staticClass: "container_center_content"
  }, [_vm._v("\n          恭喜您通过理论测试，请从下面的N道实践题中，任选一题，点击进入（也可以分别点击查看），内有相关教材或示范视频或示范文档的链接，请在15个工作日内，通过您的刻苦学习，按照实践题目的要求，上传由您亲自表演或创作的作品，上传成功后，等候评委在7个工作日内的审核，最终考试结果，将在您的考级申报窗口显示并同时用站内信箱显示，祝您成功！\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "container_center_btns"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("实践考试")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container_right"
  }, [_c('div', {
    staticClass: "container_right_title"
  }, [_vm._v("答题结果")]), _vm._v(" "), _c('div', {
    staticClass: "container_right_content"
  }, _vm._l((_vm.row.question_list), function(item, index) {
    return _c('div', [_c('span', {
      class: 'status-' + item.is_right
    }, [_vm._v("\n              " + _vm._s(index + 1) + "\n            ")])])
  }), 0)])]), _vm._v(" "), _c('div')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d3ffa4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/kaoji/ExameResult.vue
// module id = 1249
// module chunks = 0